import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { burgerMenuStore } from '../model/store';

export const BurgerButton: FC = observer(() => {
  return (
    <button
      onClick={burgerMenuStore.toggle}
      className={`burger-button ${burgerMenuStore.isOpen ? 'open' : ''}`}
      aria-label="Відкрити меню"
      aria-expanded={burgerMenuStore.isOpen}
    >
      {burgerMenuStore.isOpen ? (
        // Иконка крестика
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 23.9617L23.9617 9" stroke="#FFFCF9" stroke-width="1.8" stroke-linecap="round"/>
          <path d="M23.9617 23.9617L9 9" stroke="#FFFCF9" stroke-width="1.8" stroke-linecap="round"/>
        </svg>
      ) : (
        // Иконка бургера
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M27 9L15 9" stroke="#FFFCF9" stroke-width="1.8" stroke-linecap="round"/>
          <path d="M27 16H6" stroke="#FFFCF9" stroke-width="1.8" stroke-linecap="round"/>
          <path d="M27 23H6" stroke="#FFFCF9" stroke-width="1.8" stroke-linecap="round"/>
        </svg>

      )}
    </button>
  );
});
